import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=a0aed7f0&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"
import style0 from "./Reset.vue?vue&type=style&index=0&id=a0aed7f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_css-loader@6.8.1_w_ac75f654c89b93f746c150b40366f7f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0aed7f0",
  null
  
)

export default component.exports